exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-50d85bb6]{font-size:30px}h1[data-v-50d85bb6],h2[data-v-50d85bb6]{font-weight:700;color:#18252d}h2[data-v-50d85bb6]{font-size:20px}p[data-v-50d85bb6]{margin-top:5px;font-size:18px}", ""]);

// exports
